import React from 'react';

import { useFormContext } from 'react-hook-form';

import { FormField } from '@/_components';
import type { PhoneNumberQuerySchema } from '@/_schemas/phone-numbers';

import { PhoneNumber } from './components/phone-number';

function PhoneNumbersFormBase(props: { isEditable?: boolean; isSortable?: boolean }) {
  const form = useFormContext();

  const onChange = React.useCallback(
    (type: 'DELETE' | 'ADD' | 'UPDATE' | 'SORT') => (phoneNumbers: PhoneNumberQuerySchema[]) => {
      const updatedPhoneNumbers: Record<string, PhoneNumberQuerySchema> = {};
      let newValues: PhoneNumberQuerySchema[] = [];
      const currentPhoneNumbers = (form.getValues().phone_numbers || []) as PhoneNumberQuerySchema[];

      if (type === 'DELETE') {
        newValues = [...phoneNumbers];
      } else {
        newValues = [...currentPhoneNumbers, ...phoneNumbers];
      }

      newValues.forEach((newNumber) => {
        updatedPhoneNumbers[newNumber.id] = newNumber;
      });

      const updatedPhoneNumbersArray = type === 'SORT' ? phoneNumbers : Object.values(updatedPhoneNumbers);

      form.setValue('phone_numbers', updatedPhoneNumbersArray, { shouldDirty: true });
      // onUpdate?.({ phone_numbers: updatedPhoneNumbersArray.map((item) => item.id) });
    },
    [form]
  );

  return (
    <FormField
      control={form.control}
      name="phone_numbers"
      render={({ field }) => <PhoneNumber value={field.value} onChange={onChange} {...props} />}
    />
  );
}

export const PhoneNumbersForm = React.memo(PhoneNumbersFormBase);
